import { useState } from "react";
import { getStats, getLevel } from "../gamification";

// Simulated learners (will mix with real user)
const SIMULATED_USERS = [
  { name: "Priya S.", xp: 4850, streak: 32, level: 7, country: "🇮🇳", avatar: "👩‍💼" },
  { name: "Raj K.", xp: 4200, streak: 28, level: 6, country: "🇮🇳", avatar: "👨‍💻" },
  { name: "Ananya M.", xp: 3800, streak: 21, level: 6, country: "🇮🇳", avatar: "👩‍🎓" },
  { name: "Ahmed H.", xp: 3500, streak: 19, level: 5, country: "🇦🇪", avatar: "👨‍🏫" },
  { name: "Chen W.", xp: 3200, streak: 15, level: 5, country: "🇨🇳", avatar: "👨‍💼" },
  { name: "Maria L.", xp: 2900, streak: 14, level: 5, country: "🇧🇷", avatar: "👩‍🔬" },
  { name: "Deepak P.", xp: 2600, streak: 12, level: 4, country: "🇮🇳", avatar: "👨" },
  { name: "Fatima A.", xp: 2300, streak: 10, level: 4, country: "🇵🇰", avatar: "👩" },
  { name: "Yuki T.", xp: 2000, streak: 9, level: 4, country: "🇯🇵", avatar: "👩‍🎨" },
  { name: "Carlos R.", xp: 1800, streak: 7, level: 3, country: "🇲🇽", avatar: "👨‍🎤" },
  { name: "Sana J.", xp: 1500, streak: 6, level: 3, country: "🇮🇳", avatar: "👩‍💻" },
  { name: "Tom B.", xp: 1200, streak: 5, level: 3, country: "🇬🇧", avatar: "👨‍🏭" },
  { name: "Lisa N.", xp: 900, streak: 4, level: 2, country: "🇩🇪", avatar: "👩‍🏫" },
  { name: "Kiran D.", xp: 600, streak: 3, level: 2, country: "🇮🇳", avatar: "👨‍🎓" },
  { name: "Sophie M.", xp: 400, streak: 2, level: 1, country: "🇫🇷", avatar: "👩‍🎤" },
  { name: "Ali R.", xp: 200, streak: 1, level: 1, country: "🇹🇷", avatar: "👨‍🔧" },
  { name: "Emma K.", xp: 100, streak: 1, level: 1, country: "🇰🇷", avatar: "👩" },
];

const MEDALS = ["🥇", "🥈", "🥉"];

export default function Leaderboard() {
  const stats = getStats();
  const levelInfo = getLevel(stats.totalXp);
  const user = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [tab, setTab] = useState("weekly");

  // Insert real user into leaderboard
  const realUser = {
    name: user.name || "You",
    xp: stats.totalXp,
    streak: stats.streak,
    level: levelInfo.level,
    country: "🇮🇳",
    avatar: "⭐",
    isYou: true,
  };

  // Combine and sort
  const allUsers = [...SIMULATED_USERS, realUser].sort((a, b) => b.xp - a.xp);
  const userRank = allUsers.findIndex((u) => u.isYou) + 1;

  // Weekly = show less XP (simulate weekly reset)
  const weeklyUsers = allUsers.map((u) => ({
    ...u,
    xp: u.isYou ? stats.dailyXp * 7 || stats.totalXp : Math.round(u.xp * (0.1 + Math.random() * 0.2)),
  })).sort((a, b) => b.xp - a.xp);

  const displayUsers = tab === "weekly" ? weeklyUsers : allUsers;

  return (
    <div className="space-y-3 page-enter">
      <div>
        <h1 className="font-display text-4xl md:text-5xl font-normal text-ink-900"><em className="text-gold-500">Leaderboard.</em></h1>
        <p className="text-gray-400 text-sm mt-1">Compete with learners worldwide</p>
      </div>

      {/* Your rank card */}
      <div className="bg-gradient-to-br from-ink-900 via-gold-500 to-ink-900 rounded-2xl p-5 text-ink-900 relative overflow-hidden card-hover">
        <div className="absolute top-0 right-0 w-32 h-32 bg-paper-deep rounded-full -mr-10 -mt-10" />
        <div className="relative flex items-center gap-4">
          <div className="w-14 h-14 bg-cream-200 rounded-2xl flex items-center justify-center text-2xl font-black">
            #{userRank}
          </div>
          <div className="flex-1">
            <p className="font-black text-lg">{user.name || "You"}</p>
            <div className="flex items-center gap-3 text-paper text-sm">
              <span className="flex items-center gap-1">⭐ {stats.totalXp} XP</span>
              <span className="flex items-center gap-1 streak-fire">🔥 {stats.streak}</span>
              <span>Lv {levelInfo.level}</span>
            </div>
          </div>
          <div className="text-2xl">{userRank <= 3 ? MEDALS[userRank - 1] : "🎯"}</div>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 bg-gray-100 dark:bg-ink-800 p-1 rounded-2xl">
        {[
          { id: "weekly", label: "This Week" },
          { id: "alltime", label: "All Time" },
        ].map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)}
            className={`flex-1 py-2.5 rounded-xl text-sm font-bold transition-all ${
              tab === t.id ? "bg-white dark:bg-gray-700 text-gold-700 dark:text-ink-500 shadow-sm" : "text-gray-400"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Top 3 podium */}
      <div className="flex items-end justify-center gap-3 py-4">
        {[1, 0, 2].map((idx) => {
          const u = displayUsers[idx];
          if (!u) return null;
          const isCenter = idx === 0;
          return (
            <div key={idx} className={`flex flex-col items-center ${isCenter ? "mb-4" : ""} fade-in stagger-${idx + 1}`}>
              <div className="text-2xl mb-1">{MEDALS[idx === 0 ? 0 : idx === 1 ? 1 : 2]}</div>
              <div className={`${isCenter ? "w-16 h-16" : "w-13 h-13"} rounded-full bg-gradient-to-br ${
                idx === 0 ? "from-gold-300 to-gold-600" : idx === 1 ? "from-gray-300 to-gray-400" : "from-gold-300 to-gold-600"
              } flex items-center justify-center text-2xl shadow-lg ${u.isYou ? "ring-4 ring-gold-500" : ""}`}>
                {u.avatar}
              </div>
              <p className={`text-xs font-black mt-1 ${u.isYou ? "text-gold-700 dark:text-ink-500" : "text-gray-700 dark:text-gray-300"}`}>
                {u.isYou ? "You" : u.name}
              </p>
              <p className="text-[10px] text-gray-400 font-bold">{u.xp} XP</p>
            </div>
          );
        })}
      </div>

      {/* Full list */}
      <div className="bg-white dark:bg-ink-800 rounded-2xl border border-gray-100 dark:border-gray-700 overflow-hidden">
        {displayUsers.map((u, i) => (
          <div key={i} className={`flex items-center gap-3 px-4 py-3 transition-all ${
            u.isYou ? "bg-paper-deep dark:bg-ink-900/30 border-l-4 border-gold-500" : "border-b border-gray-50 dark:border-gray-700/50 hover:bg-gray-50 dark:hover:bg-gray-700/30"
          }`}>
            <div className={`w-8 text-center font-black text-sm ${i < 3 ? "text-gold-700" : "text-gray-400"}`}>
              {i < 3 ? MEDALS[i] : `#${i + 1}`}
            </div>
            <div className="w-9 h-9 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-lg">
              {u.avatar}
            </div>
            <div className="flex-1 min-w-0">
              <p className={`text-sm font-bold truncate ${u.isYou ? "text-gold-700 dark:text-ink-500" : "text-gray-800 dark:text-gray-200"}`}>
                {u.isYou ? `${u.name} (You)` : u.name} {u.country}
              </p>
              <p className="text-[10px] text-gray-400">Lv {u.level} • 🔥 {u.streak} day streak</p>
            </div>
            <div className="text-right">
              <p className={`text-sm font-black ${u.isYou ? "text-gold-700 dark:text-ink-500" : "text-gray-700 dark:text-gray-300"}`}>{u.xp}</p>
              <p className="text-[10px] text-gray-400">XP</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
